import { combineReducers } from 'redux';

import {reducer as notificationsReducer} from 'reapop';
import { routerReducer } from 'react-router-redux'

import userReducer from './user';
import editReducer from './edit';
import fogReducer from './fog';
import clientReducer from './client';
import defaultReducer from './default';
import currencyReducer from './currency';
import vesselReducer from './vessel';
import underwriterReducer from './underwriter';
import companyReducer from './company';
import clientContactReducer from './clientContact';
import countryReducer from './country';
import companyContactReducer from './companyContact';
import commodityReducer from './commodity';
import commodityGroupReducer from './commodityGroup';
import cargoReducer from './cargo';
import filesReducer from './Files';
import portReducer from './port';
import cargoPortReducer from './cargoPort';
import underwriterRateReducer from './underwriterRate';
import clientRateReducer from './clientRate';
import costReducer from './cost';
import invoiceReducer from './invoice';
import creationReducer from './creation';
import selectedReducer from './selected';
import client from '../graphql/client';
import { reducer as sematable } from 'sematable';

const defaultNotification = {
    status: 'info',
    position: 'tr',
    dismissible: true,
    dismissAfter: 2000,
    allowHTML: true,
    closeButton: true
};

const rootReducer = combineReducers({
    sematable,
    notifications: notificationsReducer(defaultNotification),
    routing: routerReducer,
    user: userReducer,
    edit: editReducer,
    creation: creationReducer,
    fog: fogReducer,
    client: clientReducer,
    connect: defaultReducer,
    currency: currencyReducer,
    vessel: vesselReducer,
    underwriter: underwriterReducer,
    company: companyReducer,
    clientContact: clientContactReducer,
    country: countryReducer,
    companyContact: companyContactReducer,
    cargo: cargoReducer,
    files: filesReducer,
    commodity: commodityReducer,
    commodityGroup: commodityGroupReducer,
    port: portReducer,
    cargoPort: cargoPortReducer,
    clientRate: clientRateReducer,
    underwriterRate: underwriterRateReducer,
    cost: costReducer,
    invoice: invoiceReducer,
    selected: selectedReducer,
    apollo: client.reducer(),
});

export default rootReducer;




// WEBPACK FOOTER //
// ./src/reducers/index.js